import { createMotionComponentWithFeatures } from "./utils.mjs";
const m = createMotionComponentWithFeatures();
const M = m.create("div");
export {
  M,
  m
};
